export default {
  lang: 'Język',
  currency: 'Waluta',
  validGoodUrlFail: 'to nie jest prawidłowy link do produktu',
  product: 'produkty',
  productHolder: 'Wprowadź nazwę/link produktu',
  // productHolder: 'Wprowadź nazwę lub link/Shop Link/PI',
  shop: 'Sklep',
  shopHolder: 'Wprowadź nazwę sklepu/link do sklepu',
  purchaseAgent: 'Strona główna',
  transport: 'Transport',
  manualOrdering: 'Zamówienie DIY',
  guideBook: 'Przewodnik',
  help: 'Pomoc',
  tools: 'Narzędzia',
  customerService: 'Obsługa klienta',
  purchaseGuide: 'Poradnik agenta zakupowego',
  payment: 'Płatność',
  delivery: 'Dostawa',
  afterSaleService: 'Obsługa posprzedażowa',
  insuranceCompensation: 'Ubezpieczenie i odszkodowanie',
  contactInfo: 'Dane kontaktowe',
  enterEmail: 'Wprowadź swój e-mail',
  copyRight: 'Copyright©acbuy.com Wszelkie prawa zastrzeżone',
  aboutacbuy: 'O acbuy',
  contctTime: '9/7 (09:00-18:00, czas pekiński)',
  contactEmail: "E-mail obsługi: Support{'@'}acbuy.com",
  contactMarket: "Współpraca marketingowa: Marketing{'@'}acbuy.com",
  contactCooperation: "Współpraca biznesowa: Business{'@'}acbuy.com",
  tutorial: 'Samouczek',
  serviceFee: 'Opłata serwisowa',
  orderStatus: 'Przewodnik dla początkujących',
  returnRefunds: 'Zwroty i refundacje',
  topUp: 'Doładowanie',
  paypal: 'PayPal',
  internationalCreditCard: 'Międzynarodowa karta kredytowa',
  telegraphicTransfer: 'Przelew telegraficzny',
  charges: 'Opłaty',
  mailRestrictions: 'Ograniczenia przesyłek',
  customsTaxation: 'Cło i podatki',
  receiptInformation: 'Informacje o rachunku',
  helpCenter: 'Centrum pomocy',
  contactUs: 'Kontakt',
  registerSuccess: 'Rejestracja udana',
  registerMsg:
    'Wysłaliśmy e-mail weryfikacyjny na Twój adres. Prosimy o szybkie dokończenie weryfikacji, w przeciwnym razie wpłynie to na normalne korzystanie z punktów.',
  continueShopping: 'Kontynuuj zakupy',
  continueLogin: 'Kontynuuj logowanie',
  verifyQuestion: 'Nie otrzymałeś e-maila weryfikacyjnego?',
  verifyResopnseOne: '· E-mail weryfikacyjny acbuy mógł zostać uznany za spam, sprawdź folder spam',
  verifyResopnseTwo:
    '· Dostarczenie może czasami być opóźnione o kilka minut, prosimy o cierpliwość',
  verifyResopnseThird:
    '· E-mail weryfikacyjny może być opóźniony o kilka minut. Jeśli nie otrzymałeś e-maila przez dłuższy czas, sprawdź czy nie został oznaczony jako spam lub wyślij ponownie e-mail weryfikacyjny',
  agentGuide: 'Przewodnik agenta dla początkujących',
  guideBookbtn: 'Przewodnik dla początkujących',
  everyonePro: 'Zarejestruj się teraz, aby otrzymać prezent powitalny ¥ 2280!',
  joinAffiliate: 'Dołącz teraz',
  joinacbuy: 'Dołącz do Discord acbuy, aby uzyskać więcej korzyści',
  joinDiscord: 'Dołącz do Discord',
  productPpurchase: 'Zakup produktu',
  shippingToWarehouse: 'Wysyłka do magazynu',
  qualityAssurance: 'Gwarancja jakości',
  moreCostEffective: 'Bardziej opłacalne',
  productPpurchaseContent:
    'Zakup produktu - możesz łatwo kupić dowolne przedmioty w TaoBao. Wystarczy wkleić linki do produktów TaoBao na stronę acbuy i złożyć zamówienie. Acbuy dokona zakupu za Ciebie.',
  shippingToWarehouseContent:
    'Wysyłka do magazynu - Kupuj od różnych sprzedawców z naszą usługą, a my skonsolidujemy Twoje zamówienia. Wszystkie przedmioty zostaną wysłane do Wybrany magazyn acbuy, a my uprościmy proces dla Twojej wygody.',
  qualityAssuranceContent:
    'Gwarancja jakości - Po dotarciu produktów do Wybrany magazyn acbuy przeprowadzimy kompleksową kontrolę jakości Twoich produktów i wyślemy Ci informację zwrotną z inspekcji, aby zapewnić lepsze doświadczenie użytkowania.',
  moreCostEffectiveContent:
    'Skoncentrowany transport oszczędza pieniądze - w Twoim magazynie możesz swobodnie wybierać towary i wysyłać je w jednej paczce. Dzięki globalnej usłudze wysyłkowej acbuy możesz wysłać towary w dowolne miejsce i cieszyć się prostszym i bardziej niezawodnym transportem globalnym.',
  introduction: 'Kupuj na taobao od acbuy',
  logoIntroduction: 'Rób zakupy jak milioner.',
  reviewOn: 'Opinie',
  productStoragePeriod: 'Okres przechowywania produktu',
  inspectionRules: 'Zasady inspekcji',
  afterSalesPolicy: 'Polityka posprzedażowa',
  insuranceAndCompensation: 'Ubezpieczenie i odszkodowanie',
  oneStopService: 'usługa kompleksowa',
  whatCustomersSay: 'co mówią nasi klienci',
  customerSay1:
    'acbuy to najlepszy agent zakupowy, z jakiego korzystałem - to mój pierwszy raz z acbuy, a ich produkty są tańsze niż u innych agentów, co jest naprawdę niesamowite!',
  customerSay2:
    'Po zostaniu promotorem acbuy otrzymałem zwrot w wysokości 300 juanów. Od tej pory będę otrzymywać nie mniej niż 4% zwrotu od każdego zamówienia',
  customerSay3:
    'Bardzo przyjemne doświadczenie zakupowe - korzystałem z acbuy do zakupów z Chin, produkty są dobrej jakości, świetna obsługa klienta i szybka wysyłka. Polecam!',
  customerSay4:
    'Najlepszy agent - zakup został zrealizowany tego samego dnia. Wysyłka paczki do mojego domu zajęła tylko 7 dni. To obecnie najlepszy agent',
  customerFirst: 'Klient na pierwszym miejscu, usługa premium',
  customerServiceText: 'Obsługa klienta online 9/7 (09:00-18:00, czas pekiński)',
  faqCategory: 'KATEGORIE FAQ',
  valentine: 'Walentynkowe tajemnicze pudełko rozkoszy',
  joinDiscordNew: 'DOŁącz do dyskordu',
  valentineTip: 'Dołącz do Discord po ekskluzywne prezenty',
  inviteNow: 'Zaproś teraz',
  comeHere: 'Odblokuj niesamowite nagrody!',
  viewTutorial: 'Samouczek',
  springText1: 'Jak kupować na Taobao z Acbuy',
  springText2: 'Zaproś znajomych i wygraj 2000 ¥ w gotówce.',
  springText3: 'Czas trwania wydarzenia: od 18 kwietnia do 20 maja',
  category: 'Klasyfikacja',
  hotSale: 'Produkty w sprzedaży',
  motherText1: 'Wyjątkowe Oszczędności z Okazji Dnia Matki',
  motherText2: 'Wygraj Nagrody – Weź Udział Teraz!',
  motherText3: 'Czas trwania wydarzenia: 30 kwietnia – 13 maja',
  enterNow: 'Weź Udział Teraz!',
  'i18n-000001': 'Place orders',
  'i18n-000002': 'Paste an item link to submit an order',
  'i18n-000003': 'QC&storage',
  'i18n-000004': '3-5 free QC photos & 90 free storage',
  'i18n-000005': 'Submit parcels',
  'i18n-000006': 'Bundle packaging & check the parcel',
  'i18n-000007': 'INTL ship',
  'i18n-000008': 'Cheaper line with more 150 + shipping lines',
  loveText1: 'Dołącz do szaleństwa 520',
  loveText2: 'Większe zamówienia, większe nagrody!',
  loveText3: 'Czas trwania wydarzenia: 14–24 maja',
  couponResult: 'Znaleziono {num} wyników dla „{keyword}”',
  event: 'Wydarzenia',
}
